<div class="flex-fill d-flex flex-column dx-card">
  <div class="d-flex flex-column flex-fill responsive-paddings">
    <dx-data-grid
      #dataGrid
      keyExpr="id"
      class="flex-fill d-flex flex-column"
      height="100px"
      [dataSource]="credits"
      [showBorders]="true"
      [showRowLines]="true"
      (onToolbarPreparing)="onToolbarPreparing($event)"
      (onRowDblClick)="rowDoubleClick($event)"
      >
      <dxi-data-grid-column dataField="customer.displayName" caption="Customer" width="225"></dxi-data-grid-column>
      <dxi-data-grid-column dataField="amount" [format]="{ type: 'currency', precision: 2 }" width="150"></dxi-data-grid-column>
      <dxi-data-grid-column dataField="created" width="100"></dxi-data-grid-column>
      <dxi-data-grid-column dataField="createdBy" width="100"></dxi-data-grid-column>
      <dxi-data-grid-column dataField="applied" width="100"></dxi-data-grid-column>
      <dxi-data-grid-column dataField="appliedBy" width="100"></dxi-data-grid-column>
      <dxi-data-grid-column dataField="paymentId" caption="Applied To Payment" cellTemplate="paymentTemplate" width="110"></dxi-data-grid-column>
      <dxi-data-grid-column dataField="notes"></dxi-data-grid-column>

      <div *dxTemplate="let cell of 'paymentTemplate'">
        @if (cell.data) {
          <a [routerLink]="'/payments/' + cell.data.paymentId">{{ cell.text }}</a>
        }
      </div>

      <dxo-data-grid-selection mode="multiple"></dxo-data-grid-selection>
      <dxo-data-grid-search-panel [visible]="true"></dxo-data-grid-search-panel>
      <dxo-data-grid-filter-row [visible]="true"></dxo-data-grid-filter-row>
      <dxo-data-grid-export [enabled]="true" [allowExportSelectedData]="true"></dxo-data-grid-export>
      <dxo-data-grid-state-storing [enabled]="true" type="localStorage" storageKey="credit-grid"></dxo-data-grid-state-storing>
      <div *dxTemplate="let data of 'toolbarButtons'">
        <button
          type="button"
          class="btn btn-primary me-1 mb-2"
          (click)="open(dataGrid.instance.getSelectedRowsData()[0])"
          [disabled]="dataGrid.instance.getSelectedRowsData().length !== 1"
          >
          Open
        </button>
        <button class="btn btn-success me-2 mb-2" (click)="open()">Add</button>
        <button
          class="btn btn-danger me-4 mb-2"
          (click)="delete(dataGrid.instance.getSelectedRowsData()[0])"
          [disabled]="dataGrid.instance.getSelectedRowsData().length !== 1"
          >
          Delete
        </button>
      </div>
    </dx-data-grid>
  </div>
</div>
